// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-details-modal__container {
    padding: 24px 50px 16px 50px;
}

.payment-details-modal__title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin-bottom: 24px;
}

.payment-details-modal__title .baloa-names {
    color: var(--primary-very-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .payment-details-modal .modal2__container {
        margin: 0;
        height: 100%;
        max-height: unset;
        border-radius: 0;
        background: var(--white-color);
    }

    .payment-details-modal .modal2__content {
        height: 100%;
    }

    .payment-details-modal .modal2__header {
        border-bottom: 1px solid  var(--new-input-background-color);
        padding-bottom: 12px;
    }

    .payment-details-modal__container {
        padding: 12px;
    }

}`, "",{"version":3,"sources":["webpack://./src/app/payments/components/payment-details-modal/PaymentDetailsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,SAAS;QACT,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,2DAA2D;QAC3D,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[".payment-details-modal__container {\n    padding: 24px 50px 16px 50px;\n}\n\n.payment-details-modal__title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 8px;\n    margin-bottom: 24px;\n}\n\n.payment-details-modal__title .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .payment-details-modal .modal2__container {\n        margin: 0;\n        height: 100%;\n        max-height: unset;\n        border-radius: 0;\n        background: var(--white-color);\n    }\n\n    .payment-details-modal .modal2__content {\n        height: 100%;\n    }\n\n    .payment-details-modal .modal2__header {\n        border-bottom: 1px solid  var(--new-input-background-color);\n        padding-bottom: 12px;\n    }\n\n    .payment-details-modal__container {\n        padding: 12px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
